import { ReactNode } from 'react';
import { Trans } from '@lingui/react/macro';
import { Menu, MenuDivider, MenuItem, MenuProps, SubMenu } from '@szhsin/react-menu';
import cn from 'classnames';

import Stack from '@/design_system/Stack';
import IconChevron from '@/icons/Chevron.svg';
import { createBEMClasses } from '@/utils/classname';

import '@szhsin/react-menu/dist/transitions/zoom.css';
import './FiltersMenu.css';

const { block } = createBEMClasses('filters-menu');

export const FiltersMenu = ({
  button,
  children,
  onChange,
}: {
  button: MenuProps['menuButton'];
  children: ReactNode;
  onChange?: ({ open }: { open: boolean }) => void;
}) => {
  return (
    <Menu
      menuButton={button}
      transition
      overflow="auto"
      menuClassName={block()}
      gap={4}
      onMenuChange={onChange}
      unmountOnClose={true}
    >
      {children}
    </Menu>
  );
};

export const FilterItem = ({
  children,
  empty,
  disabled,
}: {
  children: ReactNode;
  empty?: boolean;
  disabled?: boolean;
}) => {
  return (
    <MenuItem className={cn({ 'filter-item--no-result': empty })} disabled={disabled || empty}>
      {children}
    </MenuItem>
  );
};

export const FilterItemNoResults = () => {
  return (
    <FilterItem key="empty-desktop" empty>
      <Trans id="input-select.no-results">No results</Trans>
    </FilterItem>
  );
};

export const FiltersSubMenu = ({
  icon,
  label,
  onChange,
  children,
}: {
  icon?: ReactNode;
  label: ReactNode;
  onChange?: ({ open }: { open: boolean }) => void;
  children: ReactNode;
}) => {
  return (
    <SubMenu
      menuClassName={block()}
      label={
        <>
          <Stack row alignItems="center" gap="0.5rem">
            {icon}
            {label}
          </Stack>
          <IconChevron right />
        </>
      }
      onMenuChange={onChange}
      overflow="auto"
    >
      {children}
    </SubMenu>
  );
};

export const FilterDivider = ({ sub }: { sub?: boolean }) => {
  return <MenuDivider className={cn({ 'szh-menu__sub-divider': sub })} />;
};
